// The footprint of a keycap, out of KeycapBaseLayer (backfill chain 11, Oct 2026): the
// rectangles the layout editor's base layer (customizerScreen/KeycapBaseLayer.js) draws
// invisibly under each keycap, in the keycap's own coordinates (the layer places them with
// the keycap's position, offsets and rotation), and the layout save's overlap check reads
// back from the rendered preview (findOverlappingRenderedKeycaps, utils/layoutChecks.js) to
// refuse a layout whose keycaps overlap. One rectangle of the keycap's width and height;
// the ISO Enter two, so its lower-left notch stays free for the keycap beside it.
export const keycapFootprintRects = (keycap, oneKeycapUnitInMM) => {
  if (keycap.isIsoEnter) {
    return [
      {
        x: 0,
        y: 0,
        width: 1.5 * oneKeycapUnitInMM,
        height: 1 * oneKeycapUnitInMM,
      },
      {
        x: 0.25 * oneKeycapUnitInMM,
        y: 1 * oneKeycapUnitInMM,
        width: 1.25 * oneKeycapUnitInMM,
        height: 1 * oneKeycapUnitInMM,
      },
    ]; // iso enter uses two occupied rectangles so the lower-left notch stays empty
  }

  return [
    {
      x: 0,
      y: 0,
      width: keycap.width * oneKeycapUnitInMM,
      height: keycap.height * oneKeycapUnitInMM,
    },
  ]; // normal keycaps use one rectangular occupied area, of the width and height in units; the layer's `(Number(keycap.width) || 1)` fallback went in chain 11 (user decision): the layout editor renders the layer over a validated layout alone (`validLayout`, null while the validator has problems), and the validator refuses a real keycap without a numeric width or height through its type lookup (`validateKeycapType` builds the key from `Number(keycap.width)` and `Number(keycap.height)`, and `NaNx1` is no type; `KNOWN_BUGS.md`'s entry on that check wants a clearer message, and its fix has to keep refusing such a keycap), so none reaches this, and one would give NaN now (the walk's stepped and homing-bar branches read neither before drawing the footprint)
}; // the footprint rectangles of a keycap, in the order the layer numbers their parts
